export default {
  uploadImg () { return "/uploading/uploadImg" }
}